<!-- Hyperpure Cart Iframe - Standalone Page -->
<div class="hyperpure-cart-page">
    <!-- Loading Overlay -->
    <div class="loading-overlay" *ngIf="isLoading">
        <div class="loading-spinner">
            <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
            <p class="loading-text">Loading Hyperpure Cart...</p>
        </div>
    </div>

    <!-- Page Header -->
    <div class="cart-header">
        <div class="header-content">
            <div class="header-left">
                <img src="assets/images/hyperpure_icon.svg"
                    alt="Hyperpure Icon"
                    class="hyperpure-icon"
                    onerror="this.style.display='none'">
                <img src="assets/images/logo_hp.png"
                    alt="Hyperpure"
                    class="hyperpure-logo"
                    onerror="this.style.display='none'">
                <h1 class="page-title">Cart</h1>
            </div>

            <div class="header-controls">
                <!-- Debug Controls (only visible in development) -->
                <div class="debug-controls" *ngIf="!environment?.production">
                    <button class="btn btn-sm btn-outline-secondary"
                        (click)="manualSendLogin()"
                        title="Send Login Message">
                        <i class="material-icons">login</i>
                        Login
                    </button>
                    <button class="btn btn-sm btn-outline-secondary"
                        (click)="manualSendCartLoad()"
                        title="Send Cart Load Message">
                        <i class="material-icons">shopping_cart</i>
                        Load Cart
                    </button>
                </div>

                <button class="control-btn refresh-btn"
                    (click)="reloadIframe()"
                    title="Refresh">
                    <i class="material-icons">refresh</i>
                </button>
            </div>
        </div>
    </div>

    <!-- Iframe Container -->
    <div class="iframe-container" *ngIf="showIframe">
        <iframe #iframeElement
            *ngIf="iframeUrlSafe"
            [src]="iframeUrlSafe"
            class="hyperpure-iframe"
            frameborder="0"
            loading="lazy"
            allow="payment; geolocation"
            title="Hyperpure Cart"
        ></iframe>

        <!-- Iframe Loading Indicator -->
        <div class="iframe-loading" *ngIf="isLoading">
            <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading iframe...</span>
            </div>
        </div>
    </div>

    <!-- Error State -->
    <div class="error-container" *ngIf="!showIframe && !isLoading">
        <div class="error-content">
            <i class="material-icons error-icon">error_outline</i>
            <h2>Unable to Load Hyperpure Cart</h2>
            <p>Please ensure you have valid authentication credentials.</p>
            <button class="btn btn-primary" (click)="closeIframe()">
                Go Back to Purchase Manager
            </button>
        </div>
    </div>
</div>

<!-- Instructions Panel (Collapsible) -->
<div class="instructions-panel" *ngIf="!environment?.production">
    <button class="instructions-toggle"
        data-bs-toggle="collapse"
        data-bs-target="#instructionsContent">
        <i class="material-icons">info</i>
        Developer Instructions
    </button>

    <div class="collapse" id="instructionsContent">
        <div class="instructions-content">
            <h4>How to Use This Page</h4>

            <h5>Method 1: Query Parameters</h5>
            <pre>
/purchase-manager/hyperpure-cart?token=xxx&store_uuid=xxx&email=xxx&phone=xxx
            </pre>

            <h5>Method 2: Session Storage</h5>
            <pre>
sessionStorage.setItem('hyperpureLoginData', JSON.stringify(&#123;
    token: 'your_token',
    store_uuid: 'your_store_uuid',
    store_id: 'your_store_id',
    email: 'user@example.com',
    phone: '1234567890',
    session_id: 'session_id',
    all_store_obj: &#123;&#125;
&#125;));
            </pre>

            <h5>Message Topics Sent:</h5>
            <ul>
                <li><code>hyperpure_login</code> - Authenticates user with Hyperpure</li>
                <li><code>hyperpure_frame_load_cart</code> - Loads the cart view in iframe</li>
            </ul>

            <h5>Message Topics Received:</h5>
            <ul>
                <li><code>hyperpure_frame_loaded</code> - Iframe is ready</li>
                <li><code>petpooja_store_registered</code> - Store registration complete</li>
                <li><code>hyperpure_cart_updated</code> - Cart modified</li>
                <li><code>hyperpure_checkout_complete</code> - Order placed</li>
            </ul>
        </div>
    </div>
</div>
